import React from 'react';

const DashboardFooter = () => {
    return(
        <>
            <section className='footer'>
                <div className='copyright'>&copy; Copyright 2023 | All Rights Reserved</div>
            </section>
        </>
    )
}
export default DashboardFooter;